module.exports = {
  authUrl: 'https://thomas-integration-prod.azurewebsites.net/api/',
  adminUrl: 'https://thomas-integration-prod.azurewebsites.net/api/',
  authClientId: 'thomas-api_de2e54a53721a4de',
};
